<template>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header
                class="pa-4"
            >
                <div
                    class="d-flex align-center"
                >
                    <div
                        class="icon-circle"
                    >
                        <v-icon
                            color="primary"
                            large
                        >
                            $mdiFormatListCheckbox
                        </v-icon>
                    </div>
                    <h3
                        class="primary--text title ml-3"
                    >
                        Summary of Offer
                    </h3>
                </div>
                <template v-slot:actions>
                    <v-icon
                        color="primary"
                    >
                        $mdiChevronDown
                    </v-icon>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <attributes
                    small
                ></attributes>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import Attributes from './Attributes';

    import KeyPlanMixin from "./../keyplan";

    export default {
        name: "KeyPlanMobileBottom",

        mixins: [
            KeyPlanMixin
        ],

        components: {
            Attributes
        },

        data() {
            return {}
        },
    }
</script>

<style
    lang="scss"
    scoped
>
    .icon-circle {
        border: 1px solid var(--color-primary);
        border-radius: 50%;
        padding: 7px;
    }
</style>
